
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  textClassName?: string;
  size?: "sm" | "md" | "lg";
  withText?: boolean;
}

export function Logo({ 
  className, 
  textClassName,
  size = "md", 
  withText = true 
}: LogoProps) {
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-10 w-10"
  };

  const textSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className={cn("rounded-lg bg-primary flex items-center justify-center", sizeClasses[size])}>
        <svg viewBox="0 0 24 24" className="w-2/3 h-2/3 text-white" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M12 6.5C12 5.672 12.672 5 13.5 5H20.5C21.328 5 22 5.672 22 6.5V9.5C22 10.328 21.328 11 20.5 11H13.5C12.672 11 12 10.328 12 9.5V6.5Z" 
            fill="currentColor" 
          />
          <path 
            d="M12 14.5C12 13.672 12.672 13 13.5 13H20.5C21.328 13 22 13.672 22 14.5V17.5C22 18.328 21.328 19 20.5 19H13.5C12.672 19 12 18.328 12 17.5V14.5Z" 
            fill="currentColor" 
          />
          <path 
            d="M2 6.5C2 5.672 2.672 5 3.5 5H8.5C9.328 5 10 5.672 10 6.5V17.5C10 18.328 9.328 19 8.5 19H3.5C2.672 19 2 18.328 2 17.5V6.5Z" 
            fill="currentColor" 
            fillOpacity="0.7"
          />
        </svg>
      </div>
      {withText && (
        <span className={cn("font-heading font-semibold", textSizes[size], textClassName)}>
          Showee
        </span>
      )}
    </div>
  );
}
